import type { MantineColorsTuple } from '@mantine/core';

// Admin color palette optimized for professional use
export const colors: Record<string, MantineColorsTuple> = {
  // Primary blue - YochienAI brand color
  blue: [
    '#e6f2ff',
    '#cce0ff',
    '#99c7ff',
    '#66adff',
    '#3394ff',
    '#116dff', // YochienAI primary brand color
    '#0d5acc', // Primary shade
    '#094799',
    '#063466',
    '#022133',
  ],
  
  // Success green - for positive states
  green: [
    '#ebfbee',
    '#d3f9d8',
    '#b2f2bb',
    '#8ce99a',
    '#69db7c',
    '#51cf66',
    '#40c057', // Success shade
    '#37b24d',
    '#2f9e44',
    '#2b8a3e',
  ],
  
  // Warning orange - for attention states
  orange: [
    '#fff4e6',
    '#ffe8cc',
    '#ffd8a8',
    '#ffc978',
    '#ffb84d',
    '#ff9f1c',
    '#fd7e14', // Warning shade
    '#fd7e14',
    '#e8590c',
    '#d9480f',
  ],
  
  // Error red - for error states
  red: [
    '#ffe0e1',
    '#ffb1b3',
    '#ff8787',
    '#ff6b6b',
    '#fa5252',
    '#f03e3e',
    '#e03131', // Error shade
    '#c92a2a',
    '#b91c1c',
    '#a61e1e',
  ],
  
  // Neutral gray - for text and backgrounds
  gray: [
    '#f8f9fa',
    '#f1f3f4',
    '#e9ecef',
    '#dee2e6',
    '#ced4da',
    '#adb5bd',
    '#6c757d', // Neutral shade
    '#495057',
    '#343a40',
    '#212529',
  ],
  
  // Admin primary - YochienAI brand color
  admin: [
    '#e6f2ff',
    '#cce0ff',
    '#99c7ff',
    '#66adff',
    '#3394ff',
    '#1a8aff',
    '#116dff', // YochienAI primary brand color
    '#0d5acc',
    '#094799',
    '#063466',
  ],
};

// Color mappings for semantic usage
export const semanticColors = {
  primary: 'admin.6',
  success: 'green.6',
  warning: 'orange.6',
  error: 'red.6',
  info: 'blue.6',
  text: {
    primary: 'gray.9',
    secondary: 'gray.6',
    muted: 'gray.5',
    light: 'gray.4',
  },
  background: {
    default: 'white',
    muted: 'gray.0',
    subtle: 'gray.1',
    hover: 'gray.2',
  },
  border: {
    default: 'gray.3',
    muted: 'gray.2',
    subtle: 'gray.1',
  },
} as const;